module.exports = {
      id: "app-store-usage",
      viewBox: "0 0 144 48",
      url: __webpack_public_path__ + "svg-sprite-f2ca7f9d4080f6eed262da64a41d98e9.svg#app-store",
      toString: function () {
        return this.url;
      }
    }